module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Definições do curso")])]), _vm._v(" "), (_vm.coordinatedCourses && _vm.coordinatedCourses.length > 0) ? _c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "class",
      "label": "Curso",
      "disabled": _vm.coordinatedCourses.length < 2,
      "items": _vm.coordinatedCourses,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.course),
      callback: function($$v) {
        _vm.course = $$v
      },
      expression: "course"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "date_range",
      "label": "Semestre",
      "items": _vm.semesters,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.semester),
      callback: function($$v) {
        _vm.semester = $$v
      },
      expression: "semester"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "v-scale-transition",
      "offset-y": "",
      "nudge-left": 40,
      "full-width": ""
    },
    model: {
      value: (_vm.menuEnrollmentStartDate),
      callback: function($$v) {
        _vm.menuEnrollmentStartDate = $$v
      },
      expression: "menuEnrollmentStartDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Publicação e inscrição de ouvintes",
      "hint": "A partir desta data as bancas do curso no semestre informado estarão disponíveis para consulta pública e inscrição de ouvintes (alunos, professores e público externo)",
      "persistent-hint": "",
      "append-icon": "date_range"
    },
    slot: "activator",
    model: {
      value: (_vm.formattedEnrollmentStartDate),
      callback: function($$v) {
        _vm.formattedEnrollmentStartDate = $$v
      },
      expression: "formattedEnrollmentStartDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": "",
      "locale": "pt-BR"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.submitConfig('enrollmentStartDate', save)
            }
          }
        }, [_vm._v("Salvar")])], 1)]
      }
    }], null, false, 2377628968),
    model: {
      value: (_vm.configs.enrollmentStartDate),
      callback: function($$v) {
        _vm.$set(_vm.configs, "enrollmentStartDate", $$v)
      },
      expression: "configs.enrollmentStartDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": true,
      "color": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingCourses && (!_vm.coordinatedCourses || _vm.coordinatedCourses.length == 0)) ? _c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "error"
    }
  }, [_vm._v("As definições de curso só podem ser configuradas pelo coordenador")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c765a85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseConfigs.vue
// module id = 248
// module chunks = 0